import { Form, Input, Select, Button, Flex, message } from "antd";
import FormSection from "../../components/FormSection";
import PageHeader from "../../components/PageHeader";
import DiscountAppliedOn from "./formsection.tsx/DiscountAppliedOn";
import ActiveDates from "./formsection.tsx/ActiveDates";
import { useForm } from "antd/es/form/Form";
import LimitLock from "./formsection.tsx/Limit&Lock";
import { numberValidation } from "../../utils/ValidationRules";
import { formatAllDatesForSubmit } from "../../utils/DateAndTimeConvertor";
import { DiscountType } from "../../models/discount";
import { useAPI } from "../../hooks/useAPI";
import { useNavigate, useParams } from "react-router";
import { ROUTES } from "../../constants/routes.constant";
import { ENDPOINTS } from "../../constants/endpoints.constant";
import { postCall } from "../../constants/apicalls.constant";
import AmountField from "../../components/AmountField";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const CreateDiscount = () => {
  const [form] = useForm();
  const { id } = useParams();
  const { loading, error, trigger } = useAPI<{
    message: string;
    status: boolean;
    data: DiscountType;
  }>(ENDPOINTS.discount);
  const navigate = useNavigate();
  const type = Form.useWatch("type", form);
  const event = useSelector((state: RootState) => state.event);
  const onSubmit = async (values: DiscountType) => {
    const convertedValues = formatAllDatesForSubmit<DiscountType>(values);
    const rawValues = Array.isArray(convertedValues.condition_values)
      ? convertedValues.condition_values
      : event?.id
        ? [event.id]
        : [];

    const conditionValues: string[] = rawValues.filter(
      (v): v is string => v !== undefined,
    );
    convertedValues.conditions = [
      {
        condition_type: convertedValues.condition_type!,
        condition_values: conditionValues,
      },
    ];
    convertedValues.event_id = id;
    if ("condition_values" in convertedValues) {
      delete convertedValues.condition_values;
    }

    if ("condition_type" in convertedValues) {
      delete convertedValues.condition_type;
    }

    const res = await trigger(postCall(convertedValues));

    if (res && res.status) {
      navigate(ROUTES.DISCOUNT.path.replace(":id", id!));
      message.success("Discount Created Successfully");
    } else {
      navigate(ROUTES.DISCOUNT.path.replace(":id", id!));
      message.error("something went wrong");
    }
  };
  if (error) return <>Something went wrong</>;
  return (
    <div className="p-[24px]">
      <PageHeader title="Add Coupon" backBtn={true} />
      <Form
        layout="vertical"
        form={form}
        onFinish={onSubmit}
      >
        <FormSection
          withoutCard={true}
          title="Coupon Info"
          description="Set the code and tell customers what the deal is."
          dividerEnd
        >
          <>
            <Form.Item
              label="Coupon Code"
              name={"coupon_code"}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Description"
              name={"description"}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Status" name={"status"} initialValue={"active"}>
              <Select
                options={[
                  { label: "Active", value: "active" },
                  { label: "InActive", value: "inactive" },
                ]}
              />
            </Form.Item>
          </>
        </FormSection>
        <DiscountAppliedOn form={form} />
        <FormSection
          withoutCard={true}
          title="Flat or flexible"
          description="Percentage or fixed—and drop the value!"
          dividerEnd
        >
          <>
            <Form.Item
              label="Coupon Type"
              name={"type"}
              initialValue={"percentage"}
            >
              <Select
                onChange={() => form.setFieldValue("value", "")}
                options={[
                  { label: "Percentage", value: "percentage" },
                  { label: "Fixed", value: "fixed_amount" },
                ]}
              />
            </Form.Item>
            {type === "percentage" ? (
              <Form.Item
                label="Coupon Value"
                name={"value"}
                rules={numberValidation(
                  "Coupon Value",
                  "",
                  true,
                  true,
                  100,
                  "Coupon can not be greater than 100",
                )}
              >
                <Input suffix={"%"} />
              </Form.Item>
            ) : (
              <AmountField name="value" currency={event?.currency || ""} />
            )}
          </>
        </FormSection>

        <LimitLock />

        <ActiveDates form={form} />

        <Flex gap={20} justify="end">
          <Button
            block
            className="!w-auto"
            onClick={() => navigate(ROUTES.DISCOUNT.path.replace(":id", id!))}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            block
            className="!w-auto"
            loading={loading}
          >
            Create Coupon
          </Button>
        </Flex>
      </Form>
    </div>
  );
};

export default CreateDiscount;
